// extracted by mini-css-extract-plugin
export default {"welcome_placeholder":"WelcomeMessage_welcome_placeholder__4dM30","logo_normal":"WelcomeMessage_logo_normal__5Bllp"};